export default __webpack_public_path__ + "static/media/front-page-header-1.06102088.jpg";